<template>
	<div>
		<div class="list">
			<div class="row">
				<div class="no h">场次</div>
				<div class="vs br  h">对阵</div>
				<div class="bet br  h">投注内容</div>
				<div class="rs br h">赛果</div>
			</div>
			<div class="row bt" v-for="(item, index) in matchList" :key="index">
				<div class="no">{{item.no}}</div>
				<div class="vs br">
					<div>[主]{{item.home}}</div>
					<div>[客]{{item.away}}</div>
				</div>
				<div class="bet br">
					<div>
						<span v-if="lotterySign == 'bqc'">[半]</span>
						<span class='bt10' v-for="(ii,tt) in item.bets[0]" v-if="lotterySign == 'jqc'">{{ ii === 3 ? ii + '+' : ii }}</span>
						<span class='bt10' v-for="(ii,tt) in item.bets[0]" v-if="lotterySign == 'bqc'">{{ ii }}</span>
					</div>
					<div>
						<span v-if="lotterySign == 'bqc'">[全]</span>
						<span class='bt10' v-for="(ii,tt) in item.bets[1]" v-if="lotterySign == 'jqc'">{{ ii === 3 ? ii + '+' : ii }}</span>
						<span class='bt10' v-for="(ii,tt) in item.bets[1]" v-if="lotterySign == 'bqc'">{{ ii }}</span>
					</div>
				</div>
				<div class="rs br">
					<div>{{item.rs[0]}}</div>
					<div>{{item.rs[1]}}</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props:['matchList', 'lotterySign'],
		name:"jqcTable",
		data() {
			return {
				
			};
		}
	}
</script>

<style scoped lang="scss">
	.list {
		.row {
			display: flex; flex-direction: row; align-items: center;
			font-size: 12px;
			color: #333333;
			.no {
				width: 80px;
				text-align: center;
				display: flex;
				flex-direction: column;
				align-items: center;
				justify-content: center;
				padding: 4px 0;
			}
			.vs {
				width: 150px;
				display: flex;
				flex-direction: column;
				align-items: center;
				justify-content: center;
				padding: 4px 0;
			}
			.bet {
				width: 150px;
				display: flex;
				flex-direction: column;
				align-items: center;
				justify-content: center;
				padding: 4px 0;
				.bt10 {
					font-weight: bold;
					margin: 0 2px;
				}
			}
			.rs {
				width: 120px;
				display: flex;
				flex-direction: column;
				align-items: center;
				justify-content: center;
				padding: 4px 0;
			}
		}
		.h {
			background-color: #EFEFEF;
			text-align: center;
			line-height: 20px;
			height: 20px;
			font-size: 12px;
		}
		.bt {
			border-top: solid 1px #dcdcdc;
		}
		.br {
			border-left: solid 1px #dcdcdc;
		}
	}
</style>